var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9514 10.9873C40.7309 0.0417098 28.3321 -3.44516 21.0005 3.81936C13.6679 -3.44516 1.26914 0.0417098 0.0486378 10.9873C-1.17187 21.9259 20.9829 39.9827 20.997 40H21.0005C21.0171 39.9827 43.1719 21.9259 41.9514 10.9873ZM33.0326 23.3853H25.4135V30.8306H16.5542V23.3853H8.93463V14.728H16.5537V7.28208H25.413V14.7275H33.0321L33.0326 23.3853Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.22faf2c309d395debd0909b230876e10.svg";
export { ForwardRef as ReactComponent };